import React, {useEffect, useMemo, useState} from 'react';
import {Link, useParams, useRouteMatch } from 'react-router-dom'
import ReactMapGl, {Marker, Popup} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import axios from 'axios'
import {Room} from '@material-ui/icons'

const token = process.env.REACT_APP_MAP;


function Map_in_detail(props){
 let {id} = useParams();
 let {url} = useRouteMatch();
 let initWidth = window.outerWidth;
 const [tag, setTag] = useState();
 const [size, setSize] = useState(initWidth);

  const [viewport, setViewport] = useState({
      width: '40vw',
      height:'35vh',
      latitude:52.519334503212846,
      longitude:13.415270749959939, 
      zoom:11
  });

  const [museum, setMuseum] = useState([]);

  useEffect(()=>{
    getSize();
    getMuseum();
    getTag();
  },[id]);

  function getSize(){
    let widthSize = window.outerWidth
    // console.log(widthSize)
    // console.log(typeof(widthSize))
    setSize(widthSize)
  }

  function getTag(){
    let arrayUrl = url.split('/')
    let tagFromUrl = arrayUrl[3];
    setTag(tagFromUrl)
};

  function getMuseum(){
    axios.get(`/api/get_museum/${id}`)
    .then(museumDataFromMongo=>{
        setMuseum(museumDataFromMongo.data)
        
        if(size > 765) {
            setViewport({
                width: '40vw',
                height:'32vh',
                latitude:museumDataFromMongo.data.longitude,
                longitude:museumDataFromMongo.data.latitude, 
                zoom:13
            })
        } else {
            setViewport({
                width: '90vw',
                height:'200px',
                latitude:museumDataFromMongo.data.longitude,
                longitude:museumDataFromMongo.data.latitude, 
                zoom:13
            })
        }

    })
    .catch(error=>{
        console.log(error)
    })
}; 
//   function getMuseum(){
//     axios.get(`/api/get_museum/${id}`)
//     .then(museumDataFromMongo=>{
//         setMuseum(museumDataFromMongo.data)
//         setViewport({
//             width: '40vw',
//             height:'26vh',
//             latitude:museumDataFromMongo.data.longitude,
//             longitude:museumDataFromMongo.data.latitude, 
//             zoom:13
//         })

//     })
//     .catch(error=>{
//         console.log(error)
//     })
// }; 

  return(
      <div className='map'>
          <div className='exhibition_map_flex'>
          <div className='current_upcoming_flex'>
          <Link to={`/museums/list/${tag}/detail/${id}`}><p className='current_exhibition_in_map'>Current Exhibitions</p></Link>
          <Link to={`/museums/list/${tag}/detail/upcoming/${id}`}><p className='upcoming_exhibition_in_map'>Upcoming Exhibitions</p></Link>
          </div>
          <p className='map_in_map'>Map</p>
          </div>
           <ReactMapGl
          {...viewport}
          onViewportChange={nextViewport => setViewport(nextViewport)}
          mapboxApiAccessToken={token} 
          >
          {(museum.name)? 
             <Marker 
               key = {museum.name}
               latitude={museum.longitude}
               longitude={museum.latitude}
               offsetLeft={-20} 
               offsetTop={-10}
           > 
            <p><Room style={{fontSize:viewport.zoom*3, color:'black'}}/></p>
           </Marker>
          :''
           }
      </ReactMapGl>
      </div>
  )

}

export default Map_in_detail;